import { render, staticRenderFns } from "./DebtorOverviewFilter.vue?vue&type=template&id=5076f7b4&"
import script from "./DebtorOverviewFilter.vue?vue&type=script&lang=js&"
export * from "./DebtorOverviewFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports